module.exports = __webpack_public_path__ + "img/reuters.afc4a32e.png";